import React from 'react'
import { connect } from 'dva'
import { framework_tool, component_tool, utils_tool } from '@/tool'
import { modelUtils } from '@/utils'
const { WizForm } = component_tool
const { WizContainer } = framework_tool
const { isType } = utils_tool
import WizTableForm from '@/containers/common/wizTableForm/wizTableForm'

const organizationConfig = WizTableForm.Config.organizationBrandNode(this, { apiParams: { state: 1, organizationNodeCategory: [2] } })
const categoryConfig = WizTableForm.Config.categoryInfo(this, { apiParams: { type: 13, state: 1, nIdList: [14794] } })
const certConfig = WizTableForm.Config.cert(this, { apiParams: { state: 1 } })


class AddConfig extends WizContainer {

  componentName = 'AddConfig'

  constructor(props) {
    super(props)
    this.state = {
      timestamp: new Date().getTime()
    }
  }

  _ok = () => {
    this.refs.form.validateFields((err, values) => {
      if (!err) {
        this.doAction({
          path: 'certificateStatisticsCfg/add',
          payload: {
            key: 'certificateStatisticsCfg@add',
            apiParams: { ...values }
          }
        })
      }
    })
  }

  propsAndStateOnChange = {
    add: this._addOnChange.bind(this)
  }

  _addOnChange(nextProps, nextState) {
    if (nextProps.add.code === 1) {
      wizNotice.success('操作成功')
      this.props.changeModal(false)
      let { editorSuccess } = this.props
      editorSuccess && editorSuccess()
    } else {
      wizNotice.error(nextProps.save.msg)
    }
  }


  render() {
    const { record = {} } = this.props
    const columns = [{
      title: '统计内容名称',
      name: 'name',
      dataIndex: 'name',
      searchItem: {},
      formItem: {
        maxLength: 30,
        rules: [{ required: true, message: '请输入统计内容名称' }]
      },
    }, {
      title: '证书分类',
      name: 'categoryId',
      dataIndex: 'categoryId',
      formItem: {
        ...categoryConfig,
        initialValue: '',
        diy: WizTableForm,
        selectType: 'radio',
        placeholder: '请选择证书分类',
        onChangeRowMap: data => {
          if (data && isType(data, 'Object')) {
            for (let [key, value = {}] of Object.entries(data)) {
              let { certIdList = [] } = value
              this.refs.form && this.refs.form.setFieldsValue({
                certIdList
              })
            }
          }
        },
        rules: [{ required: true, message: '请选择证书分类' }]
      }
    }, {
      title: '证书级别',
      name: 'certIdList',
      dataIndex: 'certIdList',
      formItem: {
        links: { categoryId: '证书分类' },
        linksKeyFormat: { categoryId: 'category' },
        ...certConfig,
        initialValue: '',
        diy: WizTableForm,
        selectType: 'checkbox',
        placeholder: '请选择证书级别',
        rules: [{ required: true, message: '请选择证书级别' }]
      }
    }, {
      title: '品牌',
      name: 'brandId',
      dataIndex: 'brandId',
      formItem: {
        ...organizationConfig,
        initialValue: '',
        diy: WizTableForm,
        selectType: 'radio',
        placeholder: '请选择品牌',
        rules: [{ required: true, message: '请选择品牌' }]
      }
    }, {
      title: '状态',
      name: 'state',
      dataIndex: 'state',
      formItem: {
        initialValue: 1,
        type: 'Radio',
      },
      dict: [
        { code: 1, codeName: '有效' },
        { code: 0, codeName: '无效' }
      ]
    }]

    const formProps = {
      key: this.state.timestamp,
      ref: 'form',
      columns,
      record: null,
      preview: false,
      footer: <div />,
      formItemLayout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 17 }
      }
    }

    return <WizForm {...formProps} />
  }
}

const mapStateToProps = (state, ownProps) => {
  const { certificateStatisticsCfg } = state
  const add = modelUtils.getModelEntity(certificateStatisticsCfg, 'certificateStatisticsCfg@add')
  return {
    add
  }
}

const options = { withRef: true }

export default connect(mapStateToProps, null, null, options)(AddConfig)


